import React from 'react'

const SqlSprint = () => {
  return (
    <div>SqlSprint</div>
  )
}

export default SqlSprint